module.exports = __webpack_public_path__ + "media/images/communities/logos/ao12-5a18691e3cab9b1cc4e1aee718738769.png";